import { createUseStyles } from "react-jss";

export const AboutSecurityControllerStyle = createUseStyles((theme: any) => ({
    text: {
        cursor: "pointer",
        color: "var(--text-color-red)",
        fontWeight: "var(--font-weigth-bold)",
        padding: "var(--padding-sizes-xs)",
        textAlign: "center",
    },
}));
